import { render, staticRenderFns } from "./ModalReqVendor.vue?vue&type=template&id=87a169a0&scoped=true&"
import script from "./ModalReqVendor.vue?vue&type=script&lang=js&"
export * from "./ModalReqVendor.vue?vue&type=script&lang=js&"
import style0 from "./ModalReqVendor.vue?vue&type=style&index=0&id=87a169a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87a169a0",
  null
  
)

export default component.exports